import { VendorBuyingAgreementRebateCategoryDetail } from '../../../components/Vendor';

export function BuyingAgreementRebateCategory() {
  return <VendorBuyingAgreementRebateCategoryDetail />;
}
